var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20.0001 21.0089",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.56 4.58C11.2478 3.48112 11.7353 2.26904 12 1C12.5 3.5 14 5.9 16 7.5C18 9.1 19 11 19 13C19.0057 14.3823 18.6009 15.7352 17.8368 16.8871C17.0727 18.039 15.9838 18.9382 14.7081 19.4705C13.4324 20.0028 12.0274 20.1444 10.6712 19.8773C9.31493 19.6101 8.06853 18.9463 7.09 17.97M5 14.28C7.2 14.28 9 12.45 9 10.23C9 9.07 8.43 7.97 7.29 7.04C6.15 6.11 5.29 4.73 5 3.28C4.71 4.73 3.86 6.12 2.71 7.04C1.56 7.96 1 9.08 1 10.23C1 12.45 2.8 14.28 5 14.28Z",
    stroke: "var(--stroke-0, #314158)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowRate);
export default __webpack_public_path__ + "static/media/flow-rate.21ca77b6600fbc890c2ca71bd661bc53.svg";
export { ForwardRef as ReactComponent };